import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { Blobs, BlobService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-blob-details',
  templateUrl: './blob-details.component.html',
  styleUrls: ['./blob-details.component.css']
})
export class BlobDetailsComponent implements OnInit {
id: string;
blob: Observable<Blobs>;
meta: Observable<any>;
  constructor(
    private storage: AngularFireStorage,
    private blobservice: BlobService,
    private route: ActivatedRoute
    ) { }

  ngOnInit() {
this.id = this.route.snapshot.params.id;
this.blob = this.blobservice.get(this.id);
const ref = this.storage.ref('blob/'+this.id);
this.meta= ref.getMetadata();

  }

}
